import { useContext, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";

import { ITableRowData } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { IBlock } from "../../../shared/components/widgets-layout/widgets-layout";
import AuthContext from "../../../shared/context/auth-context";
import {useHttpNonTable} from "../../../shared/hooks/use-httpNonTable";
import { postSingleNonTable } from "../../../shared/utils/api";
import { validateLoadingStatusNew, IMultyChart, appendixOfy1 } from "../../../shared/utils/utils";

export interface IChartResultsCols {
    datasets: any, // eslint-disable-line
    labels: string[]
  }

export interface IRowStatus {
  opt_thresh_id?: string;
  approved_id?: string;
}

export interface ICol {
  [index: string]: any; // eslint-disable-line
}

export interface IAllColsResponse {
  columns: ICol[];
  time_unit?: string;
}

export interface ITableConfig {
  allHistoryCols?: IAllColsResponse;
  options: any; // eslint-disable-line
  applySelectedColor: any; // eslint-disable-line 
  widgetData?: IBlock;
}

export const populateHistoryObj = (history_trend_data: ITableRowData[], getResultsColsData?: any) => { // eslint-disable-line
  const prepareDatasetsList = [];

  if (getResultsColsData && history_trend_data) {
    for (const [key, value] of Object.entries(getResultsColsData?.rows?.columns)) {
      const defineAxios = appendixOfy1.find((appendixVal) => key.includes(appendixVal));

      prepareDatasetsList.push({
        label: value,
        data: history_trend_data.map((row: ITableRowData) => row?.[key]),
        borderColor: "#c4718e", 
        backgroundColor: "#c4718e", 
        key: key,
        yAxisID: defineAxios ? "y1" : "y",
      });
    }
  }
  
  return {
    labels: history_trend_data? history_trend_data.map((x: ITableRowData) => (x.timeframe_value ? x.timeframe_value : 0)) : [],
    datasets: prepareDatasetsList
  };
};

const ModelManagementChartHoc = ({ allHistoryCols, widgetData, options, applySelectedColor }: ITableConfig) => {
  const [historyChartData, setHistoryChartData] = useState<IMultyChart>({labels: [], datasets: []});

  const authCtx = useContext(AuthContext);
  const { sendRequest: getHistoryDataSortBy, status: getHistoryDataStatus, data: getHistoryDataData, error: getHistoryDataSortByError } = useHttpNonTable(postSingleNonTable, false, authCtx.token, "report", "analytics");

  useEffect(() => {
    if (getHistoryDataStatus === "completed" && !getHistoryDataSortByError && allHistoryCols) {
      const getHistory:IChartResultsCols = populateHistoryObj(getHistoryDataData.data, allHistoryCols);
      const historyDataPrep = {...getHistory, datasets: getHistory.datasets.filter((dataset:any) => widgetData?.settings?.selectedColumns.indexOf(dataset.key) !== -1)}; // eslint-disable-line
      setHistoryChartData(historyDataPrep);
    }
  }, [getHistoryDataStatus]);

  useEffect(() => {
    const columns = widgetData?.settings?.selectedColumns;
    if (!columns?.find(c => c === "timeframe_value")) {
      columns?.push("timeframe_value");
    }

    getHistoryDataSortBy("model_performance?order_by=first_day_of_week asc", {
      columns: columns,
      dataset_id: widgetData?.settings?.dataset_id,
      timeframe: widgetData?.settings?.timeframe,
    });
  }, [widgetData]);

  return (
    <div className="reportDetailsClassic-chart show">
      {validateLoadingStatusNew([getHistoryDataStatus]) && <Spinner />}
      <Line options={options} data={applySelectedColor(historyChartData)} />
    </div>
  );
};

export default ModelManagementChartHoc;